var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeOePurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.21063 13.5L3.5 16.5V4.5C3.5 4.30109 3.57902 4.11032 3.71967 3.96967C3.86032 3.82902 4.05109 3.75 4.25 3.75H16.25C16.4489 3.75 16.6397 3.82902 16.7803 3.96967C16.921 4.11032 17 4.30109 17 4.5V12.75C17 12.9489 16.921 13.1397 16.7803 13.2803C16.6397 13.421 16.4489 13.5 16.25 13.5H7.21063Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5V17.25C8 17.4489 8.07902 17.6397 8.21967 17.7803C8.36032 17.921 8.55109 18 8.75 18H17.7894L21.5 21V9C21.5 8.80109 21.421 8.61032 21.2803 8.46967C21.1397 8.32902 20.9489 8.25 20.75 8.25H17",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.25C10.8713 10.25 11.375 9.74632 11.375 9.125C11.375 8.50368 10.8713 8 10.25 8C9.62868 8 9.125 8.50368 9.125 9.125C9.125 9.74632 9.62868 10.25 10.25 10.25Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 10.25C6.74632 10.25 7.25 9.74632 7.25 9.125C7.25 8.50368 6.74632 8 6.125 8C5.50368 8 5 8.50368 5 9.125C5 9.74632 5.50368 10.25 6.125 10.25Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 10.25C14.9963 10.25 15.5 9.74632 15.5 9.125C15.5 8.50368 14.9963 8 14.375 8C13.7537 8 13.25 8.50368 13.25 9.125C13.25 9.74632 13.7537 10.25 14.375 10.25Z",
    fill: "#42296E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeOePurple);
export default __webpack_public_path__ + "static/media/question_type_oe_purple.2d56952e1cfce0bdf751c03ea59bdbcf.svg";
export { ForwardRef as ReactComponent };